import { Card, CardContent } from "@mui/material";
import Grid from "../../Grid";
import React, { useCallback, useRef, useState } from "react";
import {
  LabelCellStyle,
  ResizableScrollingTextRenderer,
} from "../../renderer/StyleRenderer";
import Button from "../../input/Button";
import { useDispatch } from "react-redux";
import { missionControlActions } from "../../../store/mission-control/mission-control-slice";
import { fetchBatchVehicleJobs } from "../../../api/missioncontrolApi";
import { errorMessageToast } from "../../../helper";

const ResultOptions = ({ results = [], close }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const gridRef = useRef();

  const dispatch = useDispatch();

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  }, []);

  const proceedHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const jobInfo = await fetchBatchVehicleJobs(selectedRows);
    dispatch(
      missionControlActions.setResults({
        results: selectedRows,
        jobInfo,
      }),
    );
    setIsLoading(false);
    close();
  };

  return (
    <Card style={{ padding: "10px" }}>
      <CardContent>
        <Grid
          ref={gridRef}
          heading="Choose upto 10 vehicles for map view"
          wrapText={false}
          multiRowSelection={true}
          onSelectionChanged={handleSelectionChanged}
          searchable={true}
          config={[
            {
              headerName: "Vehicle No",
              field: "vehicleNo",
              headerCheckboxSelection: true,
              checkboxSelection: true,
              pinned: "left",
              minWidth: 120,
              width: 120,
              filter: true,
            },
            {
              headerName: "Job",
              field: "jobCode",
              minWidth: 60,
              width: 60,
            },
            {
              headerName: "Customer",
              field: "customer",
              cellRenderer: ResizableScrollingTextRenderer,
              minWidth: 170,
              width: 170,
            },
            {
              headerName: "Event",
              field: "locationType",
              minWidth: 90,
              width: 90,
              cellRenderer: LabelCellStyle,
              cellRendererParams: (params) => ({
                color:
                  params.value === "Pickup"
                    ? "#2196F3"
                    : params.value === "Arrived"
                      ? "#4caf50"
                      : "#FFCC33",
              }),
            },
            {
              headerName: "Location",
              field: "locationName",
              cellRenderer: ResizableScrollingTextRenderer,
              minWidth: 170,
              width: 170,
            },
          ]}
          content={results}
        />
        <div className="field" style={{ width: "100%", margin: "10px 0" }}>
          <Button
            template="submit"
            disabled={selectedRows.length > 10}
            label="Proceed"
            isLoading={isLoading}
            onClick={proceedHandler}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ResultOptions;
